import _ from "lodash";
import { prettyName } from "@/helpers/user";
import { searchPublishedStatus, searchTypeMap } from "./search";

export default function makeExpandedSearchesTableData({ searches, currentOwner }) {
  return searches
    ?.filter((s) => {
      return _.get(s, ["type"]);
    })
    .map((search) => {
      if (!search) return null;

      const { assignedUsers, id, owner, title, status, clientCorporation, submissions } = search;

      /**
       * Here, the submissions were being taken from a different query,
       * when they could be retrieved from the search query instead.
       *
       * @TODO review `searchesSubmissions` maybe we don't need it any more.
       */
      // const submissions = searchesSubmissions[id] || [];

      // TODO: make work with id and not 463 once I get the right data
      // const calls = (searchesCalls && searchesCalls[id]) || [];

      // const callTime = getCallTime(calls, "hrs");
      // const converted = convertNumToTime(callTime);
      const published = searchPublishedStatus(search);

      const callTime = search?.notes?.reduce(
        (acc, { minutesSpent = 0 }) => (Number.isInteger(minutesSpent) ? minutesSpent + acc : acc),
        0
      );

      return {
        id,
        publishedCategory: _.get(search, ["publishedCategory"]),
        published,
        search: `${title} (${id})`,
        clientCorporationName: clientCorporation?.name,
        status,
        submissions,
        callTime,
        searchOwner: prettyName(owner),
        owner,
        team: _.uniqBy([..._.sortBy(assignedUsers.data, "id")], "id").map((u) => {
          u.active = currentOwner ? currentOwner.id === u.id : true;

          return u;
        }),
        priority: (_.get(search, ["type"]) && searchTypeMap[_.get(search, ["type"])]) || "Unknown",
        function: _.reduce(
          search.categories?.data,
          (string, current) => string + (_.size(string) ? ", " : "") + current.name,
          ""
        ),
        city: _.get(search, ["address", "city"]),
        launchDate: _.get(search, ["launchDate"])
          ? new Date(_.get(search, ["launchDate"]))
          : new Date("01/01/3000"),
        slateDue: _.get(search, ["slateDeliveryDate"])
          ? new Date(_.get(search, ["slateDeliveryDate"]))
          : new Date("01/01/3000")
      };
    });
}
